import { createContext } from "react";

const CatUsoCfdiContext = createContext();

export default CatUsoCfdiContext;
